// extracted by mini-css-extract-plugin
module.exports = {"root":"EditSpaceDescriptionPanel_root__19p0Z","form":"EditSpaceDescriptionPanel_form__1Urbs","title":"EditSpaceDescriptionPanel_title__3RXAn"};